@if (taskList$ | async) {
  <app-task-details></app-task-details>
}
